'use strict';

const accountActivationModal = [
  'modal',

  function (modal) {
    return {
      open: function () {
        return modal.open({
          template: '<sa-account-activation done="close()"></sa-account-activation>',
          closeOff: true
        }).result;
      }
    };
  }
];

export default accountActivationModal;



// WEBPACK FOOTER //
// ./app/src/services/account_activation_modal.js